import React from 'react'
import './App.css';
import Home from './pages';
import CashCrewReflection from './pages/CashCrewReflection'
import CashCrew from './pages/CashCrew'
import SignIn from './pages/signin'
import SignUp from './pages/signup'
import ForgotPassword from './pages/forgotpassword';
import Discussion from './pages/Discussion'
import CrewBuilder from './pages/CrewBuilder'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import About from './pages/About';
import TermsPage from './pages/Terms';
import CashCrewAI from "./pages/CashCrewAI"
import PoolsParty from "./pages/PoolParty"
import PoolFocus from "./pages/PoolFocus"


function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' element={<Home />} exact />
          <Route path='/signin' element={<SignIn />} exact />
          <Route path='/signup' element={<SignUp />} exact />
          <Route path='/reset' element={<ForgotPassword />} exact />
          <Route path='/cashcrew' exact element={<CashCrew />} />
          <Route path='/reflection' exact element={<CashCrewReflection />} />
          <Route path='/discussion' exact element={<Discussion />} />
          <Route path='/about' exact element={<About />} />
          <Route path='/crewbuilder' exact element={<CrewBuilder />} />
          <Route path='/termsofservice' exact element={<TermsPage />} />
          <Route path='/cashcrewagentic' exact element={<CashCrewAI />} />
          {/* <Route path='/poolparty' exact element={<PoolsParty />} />
          <Route path='/poolfocus' exact element={<PoolFocus />} /> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
